var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip351_13159"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Avatar",
    width: 110,
    height: 110,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Avatar",
    width: 110,
    height: 110,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip351_13159)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval 47",
    cx: 55,
    cy: 55,
    r: 50,
    fill: "#CCCCCC",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M42.604 41.3479C42.604 47.9509 48.2476 53.3044 55.2085 53.3044C62.1689 53.3044 67.8125 47.9509 67.8125 41.3479L67.8125 38.9565C67.8125 32.3535 62.1689 27 55.2085 27C48.2476 27 42.604 32.3535 42.604 38.9565L42.604 41.3479ZM62.771 41.3479C62.771 45.3096 59.3848 48.5217 55.2085 48.5217C51.0322 48.5217 47.646 45.3096 47.646 41.3479L47.646 38.9565C47.646 34.9949 51.0322 31.7827 55.2085 31.7827C59.3848 31.7827 62.771 34.9949 62.771 38.9565L62.771 41.3479ZM72.854 82L37.5625 82C33.3872 82 30 78.7866 30 74.8259L30 72.4348C30 64.51 36.772 58.0869 45.125 58.0869L65.2915 58.0869C73.6445 58.0869 80.4165 64.51 80.4165 72.4348L80.4165 74.8259C80.4165 78.7866 77.0293 82 72.854 82ZM75.375 74.8259C75.375 76.1453 74.2451 77.2173 72.854 77.2173L37.5625 77.2173C36.1719 77.2173 35.0415 76.1453 35.0415 74.8259L35.0415 72.4348C35.0415 67.1516 39.5562 62.8696 45.125 62.8696L65.2915 62.8696C70.8604 62.8696 75.375 67.1516 75.375 72.4348L75.375 74.8259Z",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatarDefault);
export default __webpack_public_path__ + "static/media/ic_avatar_default.ab41d66c8f6ad3c4e8d41af5e83abcd8.svg";
export { ForwardRef as ReactComponent };